import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { AreaProvider } from '../../providers/area/area';


@IonicPage()
@Component({
  selector: 'page-areas',
  templateUrl: 'areas.html',
})
export class AreasPage {

  areas;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public areaProvider: AreaProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
  ) {
    this.areas = this.areaProvider.getAllAreas();
  }

  add() {
    this.navCtrl.push('AreaInfoPage', { mode: 'add' });
  }

  edit(area) {
    this.navCtrl.push('AreaInfoPage', { mode: 'edit', area: area });
  }

  info(area) {
    this.navCtrl.push('AreaInfoPage', { mode: 'info', area: area });
  }

  remove(area) {
    this.alertCtrl.create({
      title: 'Eliminar un área',
      message: '¿Seguro que quiere eliminarla?',
      buttons: [
        {
          text: 'No',
          handler: () => {}
        },
        {
          text: 'Sí',
          handler: () => {
            this.areaProvider.remove(area.key).then(() => {
              this.showMessage('Área eliminada')
            });
          }
        }
      ]
    }).present();
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/areas/areas.ts